import type { ParseResult } from "papaparse";
import type { TableRow } from "react-data-table-component";
import type * as yup from "yup";
import type { ValidationError } from "yup";
import { unFlattenData } from "../../../../components/BulkUpdate/BulkUpdate";

export interface UploadDefinition<T> extends TableRow {
  success: boolean;
  original: any;
  errors?: SimpleParseError[];
  // Non-blocking row warnings attached during post-parse cleanup (e.g.
  // applyPadToDefinition stripping apostrophes / whitespace). Rows with
  // warnings still submit; they just get an amber preview row + tooltip.
  warnings?: SimpleParseWarning[];
  object?: T;
}
interface SimpleParseError {
  field?: string;
  error?: string;
}
export interface SimpleParseWarning {
  field?: string;
  warning?: string;
}

export function convertCSVToDefinitions<I>(
  data: Promise<ParseResult<any>>,
  schema: yup.ObjectSchema<any>,
): Promise<UploadDefinition<I>[]> {
  return data.then((parseData) => {
    return Promise.all(
      unFlattenData(parseData.data).map((item) => {
        return schema
          .validate(item, { abortEarly: false })
          .then((parsed) => {
            return {
              success: true,
              original: item,
              object: parsed as I,
            };
          })
          .catch((err: ValidationError) => {
            return {
              success: false,
              original: item,
              errors: err.inner.map((innerErr) => {
                return { field: innerErr.path, error: innerErr.message };
              }),
            };
          });
      }),
    );
  });
}
